/**
 * Where the Firmio desktop app is downloaded from: the latest release of the
 * public releases repository (desktop/electron-builder.yml → publish). The
 * installers keep the same file name in every release, so these links always
 * give the newest version.
 */
const RELEASES = 'https://github.com/cleanCodeCultureSRL/firmio-desktop-releases/releases';

export const DESKTOP_DOWNLOADS = {
  windows: `${RELEASES}/latest/download/Firmio-Setup.exe`,
  mac: `${RELEASES}/latest/download/Firmio.dmg`,
  all: `${RELEASES}/latest`,
};
